module.exports = __webpack_public_path__ + "media/guanwang.f0ba519b.mp4";